import baseURL from "../common/axios";
class Commonservices {
  insert(objinsert) {
    return baseURL.httpMSInventoryUrl.post("DeliveryModeMAS/Create", objinsert);
  }
  getdata() {
    return baseURL.httpMSInventoryUrl.get("DeliveryModeMAS/List");
  }
  Edit(EditID) {
    return baseURL.httpMSInventoryUrl.get(
      "DeliveryModeMAS/Get?id=" + EditID + ""
    );
  }
  Delete(DelID) {
    return baseURL.httpMSInventoryUrl.delete(
      "DeliveryModeMAS/Delete?id=" + DelID
    );
  }
  Active(Id, Status) {
    return baseURL.httpMSInventoryUrl.put(
      "DeliveryModeMAS/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  Update(objupdate) {
    return baseURL.httpMSInventoryUrl.post("DeliveryModeMAS/Update", objupdate);
  }
}
export default new Commonservices();
